import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  fetchClientCardToken,
  createClientCardToken,
  updateClientCardToken,
  deleteClientCardToken,
} from "./thunks";
import { toast } from "react-toastify";

interface ClientCardToken {
  id: string | number;
  client_id: string | number;
  token: string;
}

interface ClientCardTokenState {
  token: ClientCardToken | null;
  loading: boolean;
  error: string | null;
}

const initialState: ClientCardTokenState = {
  token: null,
  loading: false,
  error: null,
};

const clientCardTokenSlice = createSlice({
  name: "clientCardToken",
  initialState,
  reducers: {
    clearClientCardToken: (state) => {
      state.token = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchClientCardToken.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchClientCardToken.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.token = action.payload.data;
        },
      )
      .addCase(fetchClientCardToken.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        toast.error("Erro ao buscar token do cartão");
      })

      // Create
      .addCase(createClientCardToken.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        createClientCardToken.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.token = action.payload.data;
          toast.success("Token criado com sucesso!");
        },
      )
      .addCase(createClientCardToken.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        toast.error("Erro ao criar token do cartão");
      })

      // Update
      .addCase(updateClientCardToken.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        updateClientCardToken.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.token = action.payload.data;
          toast.success("Token atualizado com sucesso!");
        },
      )
      .addCase(updateClientCardToken.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        toast.error("Erro ao atualizar token do cartão");
      })

      // Delete
      .addCase(deleteClientCardToken.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteClientCardToken.fulfilled, (state) => {
        state.loading = false;
        state.token = null;
        toast.success("Token excluído com sucesso!");
      })
      .addCase(deleteClientCardToken.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        toast.error("Erro ao excluir token do cartão");
      });
  },
});

export const { clearClientCardToken } = clientCardTokenSlice.actions;
export default clientCardTokenSlice.reducer;
